<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.36 17.0002C13.2253 16.9997 13.0921 16.9719 12.9684 16.9187C12.8446 16.8654 12.7329 16.7877 12.64 16.6902L8.78 12.6902C8.59677 12.5033 8.49414 12.2519 8.49414 11.9902C8.49414 11.7284 8.59677 11.4771 8.78 11.2902L12.78 7.29019C12.8732 7.19695 12.9839 7.12299 13.1057 7.07253C13.2276 7.02207 13.3581 6.99609 13.49 6.99609C13.6219 6.99609 13.7524 7.02207 13.8742 7.07253C13.9961 7.12299 14.1068 7.19695 14.2 7.29019C14.2932 7.38342 14.3672 7.49411 14.4177 7.61594C14.4681 7.73776 14.4941 7.86833 14.4941 8.00019C14.4941 8.13204 14.4681 8.26261 14.4177 8.38444C14.3672 8.50626 14.2932 8.61695 14.2 8.71019L10.9 12.0002L14.08 15.3002C14.2662 15.4875 14.3708 15.741 14.3708 16.0052C14.3708 16.2694 14.2662 16.5228 14.08 16.7102C13.9854 16.8041 13.8729 16.8781 13.7493 16.9279C13.6256 16.9777 13.4933 17.0023 13.36 17.0002Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  name: "ArrowLeftIcon",
};
</script>
